export const safelyGetRecords = (response) => {
  try {
    if (response?.data?.data?.doc && Array.isArray(response.data.data.doc)) {
      return response.data.data.doc;
    }

    if (response?.data?.doc && Array.isArray(response.data.doc)) {
      return response.data.doc;
    }

    if (Array.isArray(response?.data)) {
      return response.data;
    }

    return [];
  } catch (error) {
    console.warn("Error parsing response structure:", error);
    return [];
  }
};
